module.exports = __webpack_public_path__ + "img/fr_fr.8dd66803.png";